/**
 * Bloc lecture seule dans les grilles U3130 (Dépenses, Équipement, Honoraires).
 * Même hauteur que les champs réels sous [&_input]:h-[46px] du wrapper overflow.
 */
export const U3130_READONLY_TABLE_CELL_BOX_CLASS =
  "box-border flex h-[46px] w-full min-w-0 shrink-0 items-center rounded-lg border border-gray-200 bg-muted px-3 text-sm leading-snug text-gray-700 cursor-not-allowed";

/** Variante compacte (h-8) — identique à `U3129_READONLY_TABLE_CELL_BOX_COMPACT_CLASS` (BL-0672). */
export const U3130_READONLY_TABLE_CELL_BOX_COMPACT_CLASS =
  "box-border flex h-8 w-full min-w-0 shrink-0 items-center rounded-md border border-gray-200 bg-muted px-2 text-sm leading-tight text-gray-700 cursor-not-allowed";

export const U3130_READONLY_TABLE_CELL_BOX_ABSENCES_HOUR_CLASS =
  "box-border flex h-8 w-full min-w-0 shrink-0 items-center rounded-md border border-gray-200 bg-muted px-1.5 text-sm leading-tight text-gray-700 cursor-not-allowed";
